module.exports = __webpack_public_path__ + "img/homeSlider.fe17549d.png";